/*-------------
IMPORTANT NOTE:
This is a custom version of the file-converter module.
It is specific to form-builder.
-------------*/
import "../file-uploader";

import FileConverterComponent from "./file-converter/file-converter.component";

const DEPENDENCIES = [
  'file-uploader'
];

angular
  .module( 'file-converter', DEPENDENCIES )
  .component( 'fileConverter', FileConverterComponent )